import Hls, { ErrorData as HlsErrorData } from 'hls.js';
import EventBus, { Event } from '@/core/event-bus';
import clientFacingHlsProvider, { ClientFacingHlsProvider } from '../utils/client-facing-hls';
import onBufferStalled from './buffer-stalled';
import onErrorDefault from './default';
import SmvpErrorHandler, { ErrorData } from './smvp-error-handler';
import onManifestError from './manifest-error';

const errors = Hls.ErrorDetails;

export const CONTEXT = 'hls';

export type HlsErrorHandler = (
    event: string,
    data: ErrorData | HlsErrorData
) => void;

export type HlsErrorPayload = {
    event: string,
    data: ErrorData | HlsErrorData,
    hls: ClientFacingHlsProvider
};

export function emitToClient(
    hls: Hls,
    eventBus: EventBus,
    event: string,
    data: ErrorData
): void {
    const payload: HlsErrorPayload = {
        event,
        data,
        hls: clientFacingHlsProvider(hls)
    };

    eventBus.emit(Event.error, payload, CONTEXT);
}

export default function createHandlers(
    hls: Hls,
    eventBus: EventBus,
    smvpErrorHandler: SmvpErrorHandler
): Record<string, HlsErrorHandler> {
    const handlers: Record<string, HlsErrorHandler> = {};

    handlers[errors.BUFFER_STALLED_ERROR] = onBufferStalled(hls, eventBus, smvpErrorHandler);
    handlers[errors.MANIFEST_LOAD_ERROR] = onManifestError(hls, eventBus);
    // manifestParsingError can happen if a backend redirect falls back to the mp4 version of a video for some reason (aggressive caching)
    handlers[errors.MANIFEST_PARSING_ERROR] = onManifestError(hls, eventBus);
    handlers[errors.MANIFEST_LOAD_TIMEOUT] = onManifestError(hls, eventBus);
    handlers[errors.MANIFEST_INCOMPATIBLE_CODECS_ERROR] = onManifestError(hls, eventBus);

    handlers.default = onErrorDefault(hls, eventBus, smvpErrorHandler);

    return handlers;
}
